import { Box } from '@mui/material'
import type { FC } from 'react'

import { unit } from '@hcr/ui'

import { Error404 } from '../error'

import { LayoutNavigation } from './LayoutNavigation'

interface LayoutNavigationError404Props {
  showContextMenuButton?: boolean
}

export const LayoutNavigationError404: FC<LayoutNavigationError404Props> = ({ showContextMenuButton }) => {
  return (
    <LayoutNavigation showContextMenuButton={showContextMenuButton} stretchContentVertically>
      <Box paddingTop={unit(19)} height='100%'>
        <Error404 />
      </Box>
    </LayoutNavigation>
  )
}
